import logo from '../assets/logo-kamae.jpg';
import './Logo.css';

/* Real brand mark: the circular Kamae crest, clipped round to drop the
   JPG's square backdrop. Drop-in replacement for the old shield Badge. */
export default function Logo({ size = 40, className = '' }) {
  return (
    <img
      src={logo}
      alt="Centro de Entrenamiento Kamae"
      width={size}
      height={size}
      className={`logo ${className}`.trim()}
    />
  );
}
